import { EventProperties } from '@calm/evexia-analytics';
import { CustomAxiosError } from '@calm/evexia-web-sdk';
import {
    RegistrationFlow,
    RegistrationFlowContextState,
} from '@rhg/hooks/use-registration-context/types';
import { identifyInvitationErrorType } from '@rhg/utils/invitations';
import { GeneralErrorDialog } from '../../general-error-dialog';
import { InvitationErrorDialog } from '../../invitation-error-dialog';

export function RegistrationContainerErrorDialog({
    registrationFlow,
    newSponsor,
    forcedError,
    setForcedError,
    createCircleReset,
    createCircleError,
    submitFlowReset,
    submitFlowError,
}: Pick<
    RegistrationFlowContextState,
    | 'registrationFlow'
    | 'newSponsor'
    | 'submitFlowReset'
    | 'submitFlowError'
    | 'createCircleReset'
    | 'createCircleError'
    | 'forcedError'
    | 'setForcedError'
>) {
    const handleClose = () => {
        createCircleReset();
        submitFlowReset();
        setForcedError();
    };

    const isNewRegistration =
        registrationFlow === RegistrationFlow.NewRegistration ||
        registrationFlow === RegistrationFlow.NewInviteeRegistration;

    const circleInvitationError = identifyInvitationErrorType(
        createCircleError as CustomAxiosError
    );
    const submitInvitationError = identifyInvitationErrorType(
        submitFlowError as CustomAxiosError
    );

    const trackProps: EventProperties = {
        ...(newSponsor ? { PartnerID: newSponsor?.id } : {}),
        IsDependent: [
            RegistrationFlow.NewInviteeRegistration,
            RegistrationFlow.ChangeOfInviteeSponsorship,
            RegistrationFlow.ExistingInviteeRegistration,
        ].includes(registrationFlow),
    };

    if (
        [circleInvitationError, submitInvitationError, forcedError].includes(
            'claimed'
        )
    ) {
        return (
            <InvitationErrorDialog
                type="claimed"
                onClose={handleClose}
                trackProps={trackProps}
            />
        );
    }

    if (
        [circleInvitationError, submitInvitationError, forcedError].includes(
            'expired'
        )
    ) {
        return (
            <InvitationErrorDialog
                type="expired"
                onClose={handleClose}
                trackProps={trackProps}
            />
        );
    }

    if (
        [circleInvitationError, submitInvitationError, forcedError].includes(
            'country'
        )
    ) {
        return (
            <InvitationErrorDialog
                type="country"
                onClose={handleClose}
                trackProps={trackProps}
            />
        );
    }

    // Generic Error
    return (
        <GeneralErrorDialog
            onClose={handleClose}
            showSupportEmail={isNewRegistration}
            showSupportMessage={isNewRegistration}
        />
    );
}
